import { hierarchy as d3_hierarchy } from 'd3-hierarchy'
import { convertRowsToData } from '../utils/dataUtils'
export default function PieDataController(rows, config) {
  let headers = rows[0]
  let propperHeaders
  let dims
  if (headers.length > 2) {
    propperHeaders = ['id', ...headers.slice(1)]
    dims = headers.length - 1
  } else {
    propperHeaders = ['id', 'value']
    dims = 1
  }
  let data = convertRowsToData([propperHeaders, ...rows.slice(1)], dims)
  if (config.dataSorting !== 'none') {
    data.sort((a, b) => {
      let diff = a.value - b.value
      return config.dataSorting === 'asc' ? diff : -diff
    })
  }

  let total = data.reduce((sum, d) => sum + +d.value, 0)
  data = data.map(d => {
    let percent = (100 * d.value) / total
    if (percent < 1) percent = '<1'
    return {
      ...d,
      percent: percent,
      id: Array.isArray(d.value) ? d.id + ' | ' + d.value.length : d.id,
      parentId: Array.isArray(d.value) ? d.id + ' | ' + d.value.length : d.id,
      label: d.id,
      value: Array.isArray(d.value) ? null : d.value,
      children: Array.isArray(d.value)
        ? d.value.map(dd => {
            return {
              id: d.id + ' | ' + dd.id,
              parentLabel: d.id,
              parentId: d.id,
              label: dd.id,
              value: dd.value,
            }
          })
        : [],
    }
  })

  let res = d3_hierarchy({ id: 'root', parentId: 'root_root', children: data })
  res.descendants().forEach(d => {
    d.id = d.data.id
    d.parentId = d.data.parentId
  })
  res
    .sum(function (d) {
      return d.value
    })
    .sort(function (a, b) {
      return b.height - a.height || b.value - a.value
    })
  return [res, ...res.descendants()]
  // return res
  // return data.map((d,i)=>{
  //   if(!d.id) d.id = i
  //   return d
  // })
}
